import styled from 'styled-components/macro'
import palette from 'src/designSystem/variables/palette'
import { FilterDropdownToggle } from 'src/components/Reusable/IndexPage/FilterBar/FilterBar.styles'

export const PrimaryButton = styled(FilterDropdownToggle)`
  border: none;
  border-radius: 8px;
  background-color: ${palette.neutral[900]};
  height: 32px;
  padding-left: 12px;
  padding-right: 12px;
  font-size: 12px;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
  color: ${palette.neutral.white};
  cursor: pointer;
  &:hover,
  &:focus,
  &:active,
  &.show {
    box-shadow: none !important;
    background-color: ${palette.neutral[900]};
  }
`

export const DropdownPrimaryButtonMenu = styled.div`
  border-radius: 16px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  padding: 8px;
`

export const DropdownPrimaryButtonMenuItem = styled.div`
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 6px 16px !important;
  border-radius: 8px;
  cursor: pointer;
  &:hover,
  &:focus,
  &:active,
  &.show {
    background-color: ${palette.neutral[100]};
  }
`
